import { VerticalTabsItemProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: VerticalTabsItemProps = {};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as VerticalTabsItemProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
